import { useTranslation } from 'react-i18next';
import HelpInfo from './HelpInfo';

export default function HelpInfoDefault() {
  const { t } = useTranslation('help_info');
  return <HelpInfo title={t('title')} text={t('text')} />;
}
